<app-prameters-home *ngIf="!showBtnParamFluxActu && !showBtnParamMenu" [@menu]></app-prameters-home>
<app-parameter-flux-actus *ngIf="showBtnParamFluxActu && !showBtnParamMenu" [myMenuFluxActu]="myMenuFluxActu" [@update]>
</app-parameter-flux-actus>
<app-parameter-menus *ngIf="showBtnParamMenu &&!showBtnParamFluxActu" [menu]="menu" [@update]></app-parameter-menus>